import { format } from 'date-fns'
import type { SyntheticEvent } from 'react'

import type { MonthlyStatus } from '@/modules/projects/components/StatementCoverage/types'
import { NUMBER_MASK } from '@/modules/projects/components/Workbench/accounts'
import { COVERAGE_SWATCH_CLASS } from '@/modules/projects/components/Workbench/coverage'
import { statementIdOfSegment } from '@/modules/projects/components/Workbench/fromProject'
import type { MapLane } from '@/modules/projects/components/Workbench/map'
import {
  fadedClass,
  type Highlight,
  OPEN_RING,
} from '@/modules/projects/components/Workbench/mapView'
import { linkStatement } from '@/modules/projects/components/Workbench/memberLink'
import { cn } from '@/utils'

interface MemberMonthProps {
  lane: MapLane
  month: MonthlyStatus
  monthIndex: number
  highlight: Highlight
  openStatementId: string | null
  onOpenSegment: (segmentId: number) => void
}

// The card spent this month, on the primary card's statement. Pointing at it rings that statement,
// a click opens it, and while it is open this month is ringed too.
export const MemberMonth = ({
  lane,
  month,
  monthIndex,
  highlight,
  openStatementId,
  onOpenSegment,
}: MemberMonthProps) => {
  const { segmentId } = month
  const statementId =
    segmentId === undefined ? null : statementIdOfSegment(segmentId)
  const link = (event: SyntheticEvent<HTMLElement>, linked: string | null) =>
    linkStatement(event.currentTarget, linked)
  return (
    <button
      type="button"
      disabled={segmentId === undefined}
      onClick={() => {
        if (segmentId !== undefined) onOpenSegment(segmentId)
      }}
      onPointerEnter={(event) => link(event, statementId)}
      onPointerLeave={(event) => link(event, null)}
      onFocus={(event) => link(event, statementId)}
      onBlur={(event) => link(event, null)}
      className={cn(
        'size-full cursor-pointer rounded transition-opacity hover:opacity-80 disabled:cursor-default',
        COVERAGE_SWATCH_CLASS[month.status],
        statementId !== null && statementId === openStatementId && OPEN_RING,
        fadedClass(highlight, month.status),
      )}
      style={{ gridColumn: monthIndex + 2, gridRow: 1 }}
      title={`${format(month.date, 'MMMM yyyy')}: spending on card ${lane.label}, printed on the ${NUMBER_MASK} ${lane.memberOf} statement. Click to open it.`}
    />
  )
}
